import React, { Component, PropTypes } from 'react';
import Joi from 'joi-browser';
import scriptLoader from 'react-async-script-loader';
import strategy from 'joi-validation-strategy';
import validation from 'react-validation-mixin';

import { RaisedButton, TextField } from 'material-ui';

class CreditCardForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledButton: true,
      stripeLoaded: false,
    };

    this.validatorTypes = {
      cardName: Joi.string().required().label('Name on Card'),
      cardNumber: Joi.string().creditCard().required().label('Credit Card')
        .options({
          language: {
            string: {
              creditCard: '!!Please check your credit card number is correct.',
            },
          },
        }),
      cardExpirationMonth: Joi.number().required().max(12).label('Expiration Month'),
      cardExpirationYear: Joi
        .string()
        .regex(/^(\d{2}|\d{4})$/)
        .required()
        .label('Expiration Year')
        .options({
          language: {
            any: {
              empty: 'is not allowed to be empty',
              required: 'is required',
            },
            string: {
              regex: {
                base: '!!Please enter a 2 or 4 digit card expiration year',
              },
            },
          },
        }),
      cardCVC: Joi
        .string()
        .regex(/^\d{3,4}$/)
        .required()
        .label('Card Verification Number')
        .options({
          language: {
            any: {
              empty: 'is not allowed to be empty',
              required: 'is required',
            },
            string: {
              regex: {
                base: '!!Please enter a 3 or 4 digit card verification number',
              },
            },
          },
        }),
    };
  }
  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props;
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.onScriptLoaded();
    }
  }
  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
      if (isScriptLoadSucceed) {
        this.onScriptLoaded();
      } else {
        this.onScriptError();
      }
    }
  }
  onScriptError = () => {
    console.error('There was an issue loading the script');
  }
  onScriptLoaded = () => {
    this.Stripe = window.Stripe;
    this.Stripe.setPublishableKey(this.props.stripePublicKey);

    this.setState({ disabledButton: false });
  }

  onValidate = (error) => {
    if (!error) {
      const {
        cardName,
        cardNumber,
        cardExpirationMonth,
        cardExpirationYear,
        cardCVC,
      } = this.refs;

      this.Stripe.card.createToken({
        name: cardName.getValue().trim(),
        number: cardNumber.getValue().trim(),
        cvc: cardCVC.getValue().trim(),
        exp_month: cardExpirationMonth.getValue().trim(),
        exp_year: cardExpirationYear.getValue().trim(),
      }, (status, response) => {
        if (status === 200) {
          this.billingProviderCallback(status, response);
        } else {
          this.setState({ disabledButton: false });
        }
      });
    } else {
      this.setState({ disabledButton: false });
      console.log(error);
    }
  }
  getValidatorData = () => {
    const {
      cardName,
      cardNumber,
      cardExpirationMonth,
      cardExpirationYear,
      cardCVC,
    } = this.refs;

    return {
      cardName: cardName.getValue().trim(),
      cardNumber: cardNumber.getValue().trim(),
      cardExpirationMonth: cardExpirationMonth.getValue().trim(),
      cardExpirationYear: cardExpirationYear.getValue().trim(),
      cardCVC: cardCVC.getValue().trim(),
    };
  }
  billingProviderCallback = (status, response) => {
    this.props.onCreateToken(status, response);
    this.setState({ disabledButton: false });
  }
  handleOnClick = (e) => {
    e.preventDefault();
    this.setState({ disabledButton: true });
    this.props.validate(this.onValidate);
  }
  render() {
    const {
      buttonText,
      buttonStyle,
      containerStyle,
      inputFieldStyle,
      submitDisabled,
    } = this.props;

    return (
      <div style={Object.assign({}, { width: '300px' }, containerStyle)}>
        <TextField
          floatingLabelText="Name On Card"
          fullWidth
          name="cardName"
          ref="cardName"
          errorText={this.props.getValidationMessages('cardName').length > 0 ?
                    this.props.getValidationMessages('cardName')[0] : null}
          tabIndex={1}
          style={Object.assign({}, inputFieldStyle)}
        />
        <br />
        <TextField
          floatingLabelText="Card Number"
          fullWidth
          name="cardNumber"
          ref="cardNumber"
          errorText={this.props.getValidationMessages('cardNumber').length > 0 ?
                    this.props.getValidationMessages('cardNumber')[0] : null}
          maxLength="16"
          tabIndex={2}
          style={Object.assign({}, inputFieldStyle)}
        />
        <br />
        <TextField
          floatingLabelText="CVN / CVC"
          fullWidth
          name="cardCVC"
          ref="cardCVC"
          errorText={this.props.getValidationMessages('cardCVC').length > 0 ?
                    this.props.getValidationMessages('cardCVC')[0] : null}
          style={Object.assign({}, { width: '40%', marginRight: '9%' }, inputFieldStyle)}
          tabIndex={3}
        />
        <TextField
          floatingLabelText="Expiration Month"
          fullWidth
          name="cardExpirationMonth"
          ref="cardExpirationMonth"
          errorText={this.props.getValidationMessages('cardExpirationMonth').length > 0 ?
                    this.props.getValidationMessages('cardExpirationMonth')[0] : null}
          style={Object.assign({}, { width: '25%', marginRight: '5px' }, inputFieldStyle)}
          tabIndex={4}
        />
        <TextField
          floatingLabelText="Expiration Year"
          fullWidth
          name="cardExpirationYear"
          ref="cardExpirationYear"
          errorText={this.props.getValidationMessages('cardExpirationYear').length > 0 ?
                    this.props.getValidationMessages('cardExpirationYear')[0] : null}
          style={Object.assign({}, { width: '25%' }, inputFieldStyle)}
          tabIndex={5}
        />
        <br />
        <RaisedButton
          label={this.props.isProcessing ? 'Processing' : buttonText}
          primary
          disabled={submitDisabled || this.state.disabledButton}
          onClick={this.handleOnClick}
          tabIndex={6}
          style={Object.assign({}, { textAlign: 'center', width: '256px', marginTop: '40px' }, buttonStyle)}
        />
      </div>
    );
  }
}

CreditCardForm.defaultProps = {
  buttonText: 'Start Subscription',
};

CreditCardForm.propTypes = {
  // Customize the value of form button
  buttonText: PropTypes.string,

  // Represent whether the form is submitable yet.
  submitDisabled: PropTypes.bool,

  // A function that is called with the response of stripe.js create token request
  getValidationMessages: PropTypes.func,

  // Represent whether the form is processing
  isProcessing: PropTypes.bool,

  // Represent scripts loading process is over or not, maybe part of scripts load failed.
  isScriptLoaded: PropTypes.bool,

  // Represent all scripts load successfully or not.
  isScriptLoadSucceed: PropTypes.bool,

  // Triggered when all scripts load successfully.
  onScriptLoaded: PropTypes.func,

  // A function that is called with the response of stripe.js create token request (status, response)
  onCreateToken: PropTypes.func,

  // A function that is called with the response of stripe.js create token request
  validate: PropTypes.func,
};

export default scriptLoader('https://js.stripe.com/v2/')(validation(strategy)(CreditCardForm));



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/CreditCardForm.jsx